/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import BcDetail from './BcDetail';
import BcInfos from './BcInfos';
import { createGlobalStyle } from 'styled-components';
import { EcrouIcon } from '../../../components/common/Icon/EcrouIcon';
import iconwarning from '../../../assets/Forms/WarningBlueIcon.svg';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import ModalComponent from '../../component/ModalComponent';
import IndicatorParams from './IndicatorParams';
import { CollectionPoolApi } from '../../../utils/api';
import { getParamsEnvironment } from '../../../utils/helpers/apiHelper';
import ErrorParameter from '../../../components/common/ErrorParameter';
import { loaderDataComponent } from '../../../utils/helper';

function CollectionPoolIndicator() {
  const collectionPoolId = window.sessionStorage.getItem('collectionPoolId');
  const contractCode = window.sessionStorage.getItem('contractCode');
  const collectionPoolName = window.sessionStorage.getItem('collectionPoolName');
  const contractId = window.sessionStorage.getItem('contractId')!;
  const [collectionPool, setCollectionPool] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    // get data for
    // call to api
    try {
      const previousYear = new Date().getFullYear() - 1;
      const promise = CollectionPoolApi.getCollectionPool(
        contractCode as string,
        collectionPoolId as string,
        collectionPoolName as string,
        previousYear,
        contractId
      );
      getParamsEnvironment(promise, setCollectionPool, setLoading, setError);
    } catch (error) {
      setError(true);
    }
  }, []);

  return (
    <>
      <Styles />
      <div className='indicator_header'>
        {openModal && (
          <ModalComponent
            tagName='collectionPool'
            content={
              <Container className='contentContainer'>
                <Container className='collectionPool-title'>
                  <EcrouIcon />
                  <Word
                    className='collectionPool-style'
                    variant='span'
                    textStyle='normalBold'
                    value='Paramètrage des seuils'
                  />
                </Container>
                <Container className='collectionPoolContainer'>
                  <IndicatorParams />
                </Container>
              </Container>
            }
            setOpenModal={setOpenModal}
          />
        )}
        <Container className='title_icon'>
          <img
            className='iconwarning'
            id='iconwarning'
            alt='iconwarning'
            src={iconwarning}
            style={{
              height: '20px',
              width: '20px',
            }}
          />
          <Word value='Déversement par temps sec constaté sur le bassin de collecte' />
        </Container>
        <Button
          type='button'
          mode='basic'
          automatedTestId='cp-ecrou-icon'
          onClick={() => setOpenModal(!openModal)}
        >
          <EcrouIcon />
        </Button>
      </div>
      <div className='pool_indicator'>
        <div className='left-side'>
          {collectionPool?.indicatorChart !== undefined && <BcDetail indicatorChart={collectionPool?.indicatorChart} />}
          <div style={{ display: 'inline-flex', justifyContent: 'center', marginBottom: 'auto', marginTop: 'auto', width: '100%', height: '75vh', alignItems: 'center' }}>{loaderDataComponent(loading)}</div>
        </div>
        <div className='right-side'>
          <BcInfos indicatorDescription={collectionPool?.indicatorDescription} />
        </div>
        {error && (
          <ErrorParameter
            message="une erreur s'est produite. Veuillez réessayer"
            title=''
            IsVisible={true}
          />
        )}
      </div>
    </>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style {
  .indicator_header{
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;
    justify-content: space-between;
    .title_icon{
      display: flex;
      flex-direction: row;
      img {
        margin-right: 15px
      }
    }
    svg {
      width: 30px;
      height: 30px;
    }
  }
  .contentContainer .collectionPoolContainer{
      align-items: center;
    }
.pool_indicator{
  display: flex;
  flex-direction: row;
  height: 100%;
  .left-side {
    flex: 3;
    display: flex;
    flex-direction: column;
  }
  
  .right-side {
    flex: 1;
    padding-left: 20px;
    box-sizing: border-box;
  }
}
.collectionPool-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
  svg{
    margin-top: 3px;
    margin-right: 5px;
  }
  span{
  font-size: 20px !important;
  }
}
.box{
  margin: calc(-20px + 5vh) auto 0px !important;
  max-height: initial !important;
  width: 50% !important;
}
}
`;
export default CollectionPoolIndicator;
